<!-- src/components/AppFooterContent.vue (Rename the file slightly for clarity) -->
<template>
  <v-container class="text-center pa-0">
    <!-- ... social media icons using v-btn ... -->
    <div class="mb-4">
      <v-btn
        @click="sendEmail"
        class="mx-2"
        icon
        variant="text"
        aria-label="Send Email to Aisha"
      >
        <!-- Corrected label from previous example -->
        <v-icon style="color: #ff921c">mdi-email</v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        icon
        variant="text"
        href="https://www.linkedin.com/in/aisha-keita/"
        target="_blank"
        aria-label="Facebook Profile"
      >
        <v-icon style="color: #ff921c">mdi-linkedin</v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        icon
        variant="text"
        href="https://github.com/AishaKEITA"
        target="_blank"
        aria-label="Facebook Profile"
      >
        <v-icon style="color: #ff921c">mdi-github</v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        icon
        variant="text"
        href="https://www.instagram.com/aishastechroom/"
        target="_blank"
        aria-label="Facebook Profile"
      >
        <v-icon style="color: #ff921c">mdi-instagram</v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        icon
        variant="text"
        href="https://www.youtube.com/@aishastechroom"
        target="_blank"
        aria-label="Facebook Profile"
      >
        <v-icon style="color: #ff921c">mdi-youtube</v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        icon
        variant="text"
        href="https://pod.link/aHR0cHM6Ly9hbmNob3IuZm0vcy8xMGJiYTY2NzgvcG9kY2FzdC9yc3M"
        target="_blank"
        aria-label="Facebook Profile"
      >
        <v-icon style="color: #ff921c">mdi-podcast</v-icon>
      </v-btn>
      <!-- ... other buttons ... -->
    </div>
    <div class="text-center mt-4 mb-2 footer-description">
      Frontend Developer and Developer Experience professional working in
      corporate Sweden. I share authentic, real-world advice about succeeding in
      tech based on my journey from frontend engineering to developer
      experience.
    </div>
    <div class="text-center mt-2 white--text">
      Copyright &copy;
      {{ currentYear }} Aisha
    </div>
  </v-container>
</template>

<script setup>
const currentYear = new Date().getFullYear();

const sendEmail = () => {
  const emailAddress = "hello.aishainsweden@gmail.com";
  const subject = "Inquiry from your personal website";
  // Use window.location.href to force browser navigation
  window.location.href = `mailto:${emailAddress}?subject=${encodeURIComponent(
    subject
  )}`;
};
</script>

<style scoped>
.white--text {
  color: white;
}
.footer-description {
  color: white;
  font-size: 0.85rem;
  opacity: 0.8;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}
</style>
